var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioempty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 93.09c111.89 0 217.09 43.58 296.21 122.7S930.91 400.11 930.91 512s-43.58 217.09-122.7 296.21S623.89 930.91 512 930.91s-217.09-43.58-296.21-122.7S93.09 623.89 93.09 512s43.58-217.09 122.7-296.21S400.11 93.09 512 93.09M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512 512-229.23 512-512S794.77 0 512 0z",
    fill: "#dcdcdc"
  })));
}
export default SvgRadioempty;